import { render, staticRenderFns } from "./MatchEventList.vue?vue&type=template&id=7659793c&"
import script from "./MatchEventList.vue?vue&type=script&lang=js&"
export * from "./MatchEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports